// library
import React from 'react';
// internal
// components
// style
import './NoTeacherRow.scss';
export default function NoTecherRow() {
  return (
    <div className="no-teacher-row">
      <div className="no-teacher-row__inner">
        Your Teacher has not yet arrived.
      </div>
    </div>
  );
}
